/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyTrxInfo } from './EvmDailyTrxInfo';

export type EvmHomeTotalTrxInfo = {
    TRXHTP: EvmHomeTotalTrxInfo.TRXHTP;
    TRXTP: EvmHomeTotalTrxInfo.TRXTP;
    DAVGTRXC: string;
    CNGP: string;
    DTRXLIST: Array<EvmDailyTrxInfo>;
};

export namespace EvmHomeTotalTrxInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
        CLAIM = 'CLAIM',
        DEPOSIT = 'DEPOSIT',
        USER = 'USER',
        AVG_GAS_PRICE = 'AVG_GAS_PRICE',
    }


}

